import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { FormField } from '@nuso/forms/data-access';
import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-checkbox-input',
    templateUrl: './checkbox-input.component.html',
    styleUrls: ['./checkbox-input.component.css'],
    standalone: false
})
export class CheckboxInputComponent extends BaseFormInput {
  @Input() override field: FormField;

}
